// extracted by mini-css-extract-plugin
export var button = "DisplaySwitch-module--button--22d7e";
export var displaySwitchButtons = "DisplaySwitch-module--displaySwitchButtons--5cba5";